var app = angular.module("leonardo");

var CountryList = function($scope, $state, $controller, ngDialog, CountryService, FilterService) {

  $scope.getEntitiesPromise = function(options) {
    options['name'] = FilterService.getFilter('name');
    return CountryService.getlist(options);
  };

  $scope.editCountry = function(country){
    $state.go('countries.edit', {pk: country.id});
  };

  $scope.viewCountryLevels = function (country) {
    $state.go('countries.levels', {country: country.id});
  };

  $scope.showDeleteCountry = function(country){
    ngDialog.openConfirm({
      template: 'views/templates/dialog/delete.html',
      controller: 'DeleteDialog',
      data: {
        object: country,
        type: 'country'
      }
    }).then(function(data){
      CountryService.updateCollection(data, true);
      $scope.loadPage($scope.page);
    });
  };

  $controller('TableFilterController', { $scope: $scope });
  $scope.loadPage(1);

};

app.controller('CountryList', ['$scope', '$state', '$controller', 'ngDialog', 'CountryService', 'FilterService', CountryList]);
